import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { battleApi } from '@/enitites/battle'

interface DownloadCSVButtonProps {
  battleId: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadCSVButton',
  props: {
    battleId: null
  },
  setup(__props: any) {

const props = __props as {
  battleId: number
};

const loadingCSV = ref(false)



async function downloadSCV() {
  loadingCSV.value = true
  await battleApi.downloadCSV(props.battleId)
  loadingCSV.value = false
}

return { __sfc: true,loadingCSV, props, downloadSCV }
}

})